module.exports = __webpack_public_path__ + "static/img/zlhz.4c773430.jpg";